import React from "react";
import sendVideoPlayEvent from "../../sendVideoPlayEvent";
import { Video } from "~/common/MediaViewerV2/model";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";
interface VideoMediaRendererProps {
  video: Video;
  selectedMediaIndex: number;
}
const VideoMediaRenderer = ({
  video,
  selectedMediaIndex
}: VideoMediaRendererProps) => <div className="box-border flex items-center h-full max-h-screen pb-12 w-full xl:px-40" data-sentry-component="VideoMediaRenderer" data-sentry-source-file="VideoMediaRenderer.tsx">
    <div className="w-full relative max-h-screen box-border" key={video.id}>
      <ZestVideoPlayer onPlay={() => sendVideoPlayEvent(video.sources)} posterImage={video.poster} sources={video.sources} currentIndex={selectedMediaIndex} selected={selectedMediaIndex} title={video.title} youtubeId={video.youtubeId} closedCaptionsrc={video.closedCaptionFile} playsInline data-sentry-element="ZestVideoPlayer" data-sentry-source-file="VideoMediaRenderer.tsx" />
    </div>
  </div>;
export default VideoMediaRenderer;